import React, {useEffect} from 'react'
import {change, Field, reduxForm} from 'redux-form'
import { FormButtons, renderers } from '../../components'
import * as ReactBootstrap from 'react-bootstrap'

import {useDispatch} from "react-redux";
let OTPOptionsForm = (props) => {
     const dispatch = useDispatch()
  const { handleSubmit, pristine, reset, submitting, contactNumbers } = props
  const contactNumbersOptions = contactNumbers
    useEffect(() => {
    if(contactNumbers){
        dispatch(change('OTPOptionsForm', 'contact_number', contactNumbers[0]))
    }

  }, [props.contactNumbers])
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col className={'ml-4'} xs>
          {contactNumbersOptions &&
            contactNumbersOptions
              .filter((x, i, a) => a.indexOf(x) === i)
              .map((description, index) => (
                <Field
                  name="contact_number"
                  value={description}
                  key={index + description}
                  label={description}
                  component={renderers.renderRadioFieldWithClickableLabel}
                  type="radio"
                />
              ))}
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
OTPOptionsForm = reduxForm({
  form: 'OTPOptionsForm',
})(OTPOptionsForm)

export default OTPOptionsForm
